import { isEmpty } from 'lodash';

const checkShowParentAccount = (formField) => {
  return formField?.platform?.label === 'Tiktokshop' && !isEmpty(formField?.accountType) && formField?.accountType?.label !== 'Official';
};

export default checkShowParentAccount;
